// extracted by mini-css-extract-plugin
module.exports = {"c1qen91c":"c1qen91c"};